module.exports = __webpack_public_path__ + "static/ehpad-95130122ad75a35ad7ffb270ac08843e.jpg";